import axios from 'axios';
import env from '../config/env';

const httpClient = axios.create();

httpClient.defaults.timeout = env.api.timeout;

export default {
  httpClient,
};
